import { useDecision } from '@optimizely/react-sdk'

export function useSpicyRecipeDetailsEnabled() {
  const [spicyRecipeDetails] = useDecision('turnips_ofx_spicy_recipe_details')

  return spicyRecipeDetails.variationKey === 't1'
}
